import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "dimmed",
  style: {"display":"block"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, "다시 접속해주세요.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_popup_component = _resolveComponent("popup-component")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", _hoisted_1, null, 512), [
      [_vShow, _ctx.showDimmed]
    ]),
    _withDirectives(_createVNode(_component_popup_component, { onConfirm: _ctx.closeWebView }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showReconnectionPopup]
    ])
  ], 64))
}